// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1uQLD","approved":"Status_approved__AxQ81","rejected":"Status_rejected__3yHLl","expired":"Status_expired__1c3wk","label":"Status_label__2LT8X"};